<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageFull titlePage>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content">              
                <div class="image"><img src="@/assets/images/photo_gallery/titlepage_photo-gallery_interior.jpg" alt=""></div>
                <div class="page-content content">                  
                    <div class="text-content">
                        <transition appear name="slide-fade">              
                            <h1>Interior</h1>
                        </transition>            
                    </div>                    
                </div>
            </div>
        </div>
    </template>
    </PageFull>    
  </div>
</template>

<script>
import PageFull from "@/patterns/PageFull.vue";
export default {
  name: "Marketing",
  components: { PageFull },
  data: () => ({
    scrollContent: false,    
  }),  
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>
